import { Box } from '@usealloy/component-library';
import styled, { css } from 'styled-components';
import { Colors, RebrandColors } from '~/constants';

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 32px;
`;

const StyledLabel = styled.label`
    font-weight: normal;
    font-size: 14px;
    margin: 0;
`;

const StyledLabelOptional = styled.span`
    font-size: 14px;
    font-style: italic;
`;

const StyledWarningWrapper = styled.div<{ width: number }>`
  width:  ${props => props.width}px;
  margin: 8px 0 0;
  padding: 10px 8px;
  background: ${RebrandColors.SMOKE_GREY};
  border-radius: 4px;
  font-size: 13px;
  display: flex;

  > svg {
    flex-shrink: 0;
  }
`;

const StyledWarning = styled.span`
  margin-left: 8px;
`;

const StyledInput = styled.input<{ hasError: boolean }>`
    width:  ${props => props.width}px;
    height: 40px;
    margin: 8px 0 0;
    border: ${props => (props.hasError ? `solid 1px ${RebrandColors.DENIED}` : `solid 1px ${RebrandColors.NEUTRAL_GREY}`)};
    font-size: 16px;
    padding: 10px 8px;
    border-radius: 4px;
`;

const StyledSpan = styled.span`
    font-size: 12px;
    color: ${RebrandColors.DENIED};
    padding-top: 8px;
`;

// Search Input Styles
const IconStyles = css`
  svg {
    position: relative;
    top: 37px;
    left: 10px;
  }

  input {
    padding-left: 36px;
  }

  > div {
    padding-bottom: 0px;
  }
`;
const StyledSearchDiv = styled.div`
  ${IconStyles}
`;

const StyledForm = styled.form`
  heigh: 0px;
`;

export const StyledDropdownWrapper = styled.div`
  position: relative;
  margin-top: 8px;

  &.dropdownWrapper--section {
    margin-top: 1rem;
  }
`;

export const StyledDropdownSelect = styled.select`
  &&& {
    width: 100%;
    border: 1px solid ${RebrandColors.NEUTRAL_GREY};
    box-sizing: border-box;
    min-height: 40px;
    font-size: 16px;
    padding: 0 8px;
    display: flex;
    align-content: center;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
        border-color: ${Colors.FOCUS_BLUE};
    }
  }
`;

export const StyledDropdownArrow = styled.span`
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  border-color: ${RebrandColors.INK_BLACK};
  border-bottom: 1px solid;
  border-left: 1px solid;
  transform: rotate(-45deg);
  top: 0.9rem;
  right: 0.625rem;
  z-index: 100;
`;

export const StyledCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0.25rem 0.6rem 0.25rem 0;
`;

export const StyledCheckboxLabel = styled.label`
  font-size: 1rem;
  margin: 0 0.625rem;
`;

export const StyledCheckboxBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 1.5rem 0rem 0;

  &.checkboxBody--section {
    margin-top: 1rem;
  }

  input {
    color: ${RebrandColors.NEUTRAL_GREY};
  }
`;

export const StyledCheckboxWarning = styled.div`
  margin-left: 22px;
  font-size: 12px;
`;

export const SelectWrapper = styled(Box)`
  padding-bottom: var(--cl-space-5);
`;

export const SelectInputWrapper = styled(Box)`
  margin: 0 var(--cl-space-2);
`;

export {
  StyledDiv,
  StyledLabel,
  StyledLabelOptional,
  StyledWarningWrapper,
  StyledWarning,
  StyledInput,
  StyledSpan,
  StyledSearchDiv,
  StyledForm,
};
